import { render, staticRenderFns } from "./AgreementBtn.vue?vue&type=template&id=68d8c59c&scoped=true"
import script from "./AgreementBtn.vue?vue&type=script&lang=js"
export * from "./AgreementBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8c59c",
  null
  
)

export default component.exports